const environmentStageMap = {
  "beta.bgov.com": "staging",
  "www.bgov.com": "production"
} as Record<string, Environment>

export type Environment = "development" | "staging" | "production" | "test"

export const environment: Environment =
  environmentStageMap[window.location.host] || process.env.NODE_ENV

export const appVersion = process.env.VUE_APP_VERSION || 'development'
/*
 * These are the write keys for the various Segment environments.
 * Astute readers are probably asking:
 *
 * WHY ARE YOU STORING THESE SECRETS IN SOURCE CODE!?
 *
 * The answer is that they aren't actually secrets in this case.
 * Any user of our site can easily see this key by inspecting the
 * requests in their browser's network tab, and client-side analytics
 * write keys are by their very nature not able to be secret.  While
 * we might eventually work this to somehow be built without these
 * being included, the fact that we perform one build for staging and
 * production means we need to have both available at build time anyway.
 * This is the best balance of working and easy I've found, but I'm
 * open to suggestions to improve.
 */
const segmentWriteKeys = {
  development: "JWnLRIb143PHX0tJ5bLZMT7pWOTHkxaM",
  staging: "1NHlkQbNS7enXYPlqef1jq6xO0Zt8PLh",
  production: "gOkXyMmjkyQVQ3LM0R9h8NE6PyFFX6Kd",
} as Record<Environment, string>

export const segmentWriteKey = segmentWriteKeys[environment]
